import React from "react";
import { motion } from "framer-motion";

/**
 * Statement — a bold, oversized editorial headline placed between the Marquee
 * and the Manifesto. Reinforces the brand ethos in one line.
 */
export const Statement = () => {
  return (
    <section
      id="statement"
      data-testid="section-statement"
      className="relative bg-black text-white py-32 md:py-44 overflow-hidden border-y border-white/5"
    >
      {/* subtle radial wash */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] rounded-full bg-[radial-gradient(circle,rgba(229,228,226,0.08)_0%,transparent_60%)]" />
        <div className="absolute inset-0 grain-overlay opacity-[0.08]" />
      </div>

      <div className="relative max-w-[1500px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="flex items-center gap-3 mb-8 md:mb-10"
        >
          <span className="w-10 h-px bg-silver-300" />
          <span className="font-mono text-[10px] tracking-[0.42em] text-silver-300">
            §STATEMENT
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white leading-[0.92] tracking-[-0.03em] text-[13vw] md:text-[8.2vw]"
        >
          You will not be
          <br />
          <span className="italic text-silver-100">motivated.</span>
          <br />
          You will be
          <br />
          <span className="not-italic text-white">forged.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="mt-14 md:mt-20 grid grid-cols-12 gap-6 items-end border-t border-white/10 pt-8"
        >
          <p className="col-span-12 md:col-span-6 text-white/65 leading-[1.85] text-[15px] md:text-[16px] max-w-xl">
            Motivation dies at dawn. Discipline outlasts the alarm, the season,
            the crowd. We do not chase the feeling — we return, daily, to the
            work that made us.
          </p>
          <div className="col-span-12 md:col-span-6 md:text-right">
            <div className="font-mono text-[10px] tracking-[0.42em] text-silver-300">
              — GOD FIRST · GRIND ALWAYS
            </div>
            <div className="mt-2 font-mono text-[10px] tracking-[0.32em] text-white/40">
              MBS OVERLOAD · CH. 00
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Statement;
